import { render, staticRenderFns } from "./CurrentFight.vue?vue&type=template&id=fa0d8e62&scoped=true&lang=pug&"
import script from "./CurrentFight.vue?vue&type=script&lang=js&"
export * from "./CurrentFight.vue?vue&type=script&lang=js&"
import style0 from "./CurrentFight.vue?vue&type=style&index=0&id=fa0d8e62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0d8e62",
  null
  
)

export default component.exports